import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { useNavigate } from "react-router-dom";

const Terms = () => {
  const navigate = useNavigate();
  const handleBookingClick = () => navigate("/book");

  return (
    <div className="min-h-screen bg-background">
      <Header onBookingClick={handleBookingClick} />
      
      <main className="container mx-auto px-4 py-16">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-serif mb-8">Terms of Service</h1>
          <div className="prose prose-lg max-w-none space-y-6">
            
            <section>
              <h2 className="text-2xl font-semibold mb-4">Services</h2>
              <p>Organize by Design provides professional home organization services including decluttering, organizing systems, real estate preparation, and specialized ADHD-friendly solutions.</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">Booking and Payment</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>Services are scheduled by appointment only</li>
                <li>Payment is due upon completion of services unless other arrangements are made</li>
                <li>Cancellations must be made at least 24 hours in advance</li>
                <li>A cancellation fee may apply for last-minute cancellations</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">Client Responsibilities</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>Provide accurate information about the project scope</li>
                <li>Ensure safe access to work areas</li>
                <li>Remove valuable or fragile items before our arrival</li>
                <li>Be present or designate a representative during services</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">Limitation of Liability</h2>
              <p>Our liability is limited to the cost of services provided. We are not responsible for damage to items that are not properly disclosed as fragile or valuable.</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">Confidentiality</h2>
              <p>We maintain strict confidentiality regarding your personal information and home environment. Photos may only be taken with written permission.</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">Contact Information</h2>
              <p>For questions about these terms, contact us at:</p>
              <p>Email: hello@organizebydesignmichigan.com<br />
              Phone: 616 727-0343</p>
            </section>

            <section>
              <p className="text-sm text-muted-foreground">Last updated: January 2025</p>
            </section>
          </div>
        </div>
      </main>

      <Footer onBookingClick={handleBookingClick} />
    </div>
  );
};

export default Terms;